import { action } from 'satcheljs';

/**
 * action to set or unset isDifferentReplyForOrgAndExternalSenders
 * @param isReplyOnlyToMyOrganization - the new value for isDifferentReplyForOrgAndExternalSenders
 * public action
 */
const setIsDifferentReplyForOrgAndExternalSenders = action(
    'setIsDifferentReplyForOrgAndExternalSenders',
    (isDifferentReplyForOrgAndExternalSenders: boolean) => ({
        isDifferentReplyForOrgAndExternalSenders,
    })
);

export default setIsDifferentReplyForOrgAndExternalSenders;
